import React from 'react';
import { renderRichText } from '@helpers/rendering';
import * as styles from './style.module.scss';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import plusIcon from '@icons/plusIcon';

const {
  boxSection,
  boxSection__boxes,
  boxSection__box,
  boxSection__text,
  boxSection__icon,
} = styles;

const KeywordsSection = ({ content }) => {
  const image = getImage(content.image?.gatsbyImageData);
  return (
    <section className={boxSection}>
      <h4>{content.title}</h4>
      {renderRichText(content.keywordsParagraph)}

      <div className={boxSection__boxes}>
        {content.keywords.map((item, index) => (
          <>
            <div className={`${boxSection__box} background--white`}>
              {item.icon?.svg.originalContent && (
                <span
                  className={boxSection__icon}
                  dangerouslySetInnerHTML={{
                    __html: item.icon?.svg.originalContent,
                  }}
                />
              )}
              <p>
                <strong>{item.filter}</strong> {item.value}
              </p>
            </div>

            {index !== content.keywords.length - 1 && plusIcon}
          </>
        ))}
      </div>

      {image && <GatsbyImage image={image} alt={content.image?.description} />}
      <span className={boxSection__text}>{content.imageDescription}</span>
    </section>
  );
};

export default KeywordsSection;
